import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const templateMngService = {
    getByID,
    list,
    add,
    mod,
    del,
    addTheme,
    modTheme,
    delTheme,
    downloadFile
};

function getByID(templateID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/template/get/${templateID}`, headers);
}

function list() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/template/list`, headers);
}

function add(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/templatemng/add`, formData, headers);
}

function mod(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/templatemng/mod`, formData, headers);
}

function del(templateID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/templatemng/del/${templateID}`, headers);
}

function addTheme(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/templatemng/addTheme`, formData, headers);
}

function modTheme(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/templatemng/modTheme`, formData, headers);
}

function delTheme(themeID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/templatemng/delTheme/${themeID}`, headers);
}

function downloadFile(kind, targetID) {
    const headers = {headers: authHeader(), responseType: 'arraybuffer'};
    return get(httpHelper.getApiUrl()+`/template/download/${kind}/${targetID}`, headers);
}
